import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';



class Classes extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='Classes'>
      <div><Link to='/'>Home</Link></div>
      <h3>CU Aikido Club's Classes</h3>

      <br />
      <br />

        <div><Link to='/rosterchula'>Monday 17.30-19.30</Link></div>
        <br />
        <div><Link to='/rosterchula'>Wednesday 17.30-19.30</Link></div>
        <br />
        <div><Link to='/rosterchula'>Friday 17.30-19.30</Link></div>
        <br />
        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Classes;
